import React, { Suspense } from "react";
import { usePageInit } from "src/common/hooks";
import { Loading } from "src/components";
import { useTranslate } from "@tolgee/react";

const Approve = React.lazy(() => import("./ApprovePage"));

function ApprovePage(props) {
  const { t } = useTranslate();
  usePageInit(t({ key: "approve.page.document-title", defaultValue: "Smart Portal - Approve" }));
  return (
    <Suspense
      fallback={
        <Loading
          addContainer
          active
          loadingText={t({ key: "approve.widget.loading", defaultValue: "Loading CTM Approve" })}
        />
      }
    >
      <Approve {...props} />
    </Suspense>
  );
}

export default ApprovePage;
